import { TCallbackFn } from '@src/models/common';
import { debounce } from 'lodash';
import { useMemo } from 'react';

import { useEventCallback } from './useEventCallback';

/** Хук для стандартной функции debounce, используется для оптимизации выполнения большого кол-ва вызовов определенного колбека
 * @param cb - колбек выполнения
 * @param delay - таймаут в мс, после которого будет выполнен последний вызов колбека
 * @returns функция для использования при оформлении подписки
 * @example
 *
 * const handleResize = useDebounce(() => {
 *  console.log(example)
 * }, 1000)
 *
 * window.addEventListener('resize', handleResize);
 */
export const useDebounce = <A extends unknown[], R = void>(
  cb: TCallbackFn<A, R>,
  delay: number,
): TCallbackFn<A, R | undefined> => {
  const eventCallback = useEventCallback(cb);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => debounce(eventCallback, delay), [delay]);
};
